const InternacaoOptions = [
  { id: 1, text: "Particular", value:"Particular" },
  { id: 2, text: "Convênio", value:"Convenio" },
];

export { InternacaoOptions};
